import styled from 'styled-components';

export const GrayContainer = styled.div`
  background: #222;
  border: 1px solid #333;
  padding: 5px 10px;
  display: flex;
  align-content: center;
  justify-content: space-between;
`;


// WEBPACK FOOTER //
// ./src/components/ui/containers.js